import { error, redirect } from "@sveltejs/kit";
import { p as prisma } from "../../../../../chunks/prisma.js";
const GET = async ({ url, locals }) => {
  const ref = url.searchParams.get("ref");
  if (!ref) throw error(400, "Missing ref");
  if (!locals.user) throw error(401, "Not authenticated");
  const payment = await prisma.payment.findFirst({ where: { providerRef: ref } });
  if (!payment) throw error(404, "Payment not found");
  if (payment.userId !== locals.user.id) throw error(403, "Forbidden");
  if (payment.status === "SUCCEEDED") {
    throw redirect(303, "/product?payment=success");
  }
  const mergedPayload = {
    ...payment.rawPayload || {},
    confirmedBy: "redirect"
  };
  await prisma.payment.update({
    where: { id: payment.id },
    data: {
      status: "SUCCEEDED",
      rawPayload: mergedPayload
    }
  });
  const rp = mergedPayload || {};
  if (rp.type === "DOCUMENT_PURCHASE" && rp.documentId) {
    try {
      const productDocumentId = Number(rp.documentId);
      if (!Number.isFinite(productDocumentId) || productDocumentId <= 0) {
        console.error("entitlement skipped (confirm): invalid productDocument id", rp.documentId);
      } else {
        const pd = await prisma.productDocument.findUnique({ where: { id: productDocumentId } });
        if (!pd) {
          console.error("entitlement skipped (confirm): productDocument not found", productDocumentId);
        } else {
          let secureDoc = null;
          if (pd.documentId) {
            secureDoc = await prisma.document.findUnique({ where: { id: pd.documentId } });
          }
          if (!secureDoc) {
            secureDoc = await prisma.document.create({
              data: {
                title: pd.originalName || `productdoc-${pd.id}`,
                pageCount: pd.pageCount ?? 0,
                wrappedKey: `auto-created-${Date.now()}`
              }
            });
            try {
              await prisma.productDocument.update({ where: { id: pd.id }, data: { documentId: secureDoc.id } });
            } catch (updErr) {
              console.error("failed to link productDocument -> document (confirm):", updErr?.message || updErr);
            }
          }
          try {
            await prisma.entitlement.create({
              data: {
                userId: payment.userId,
                documentId: secureDoc.id
              }
            });
          } catch (entErr) {
            console.error("entitlement create error (confirm):", entErr?.message || entErr);
          }
          try {
            const existingOrder = await prisma.order.findFirst({ where: { billRefNumber: payment.providerRef ?? void 0 } });
            if (!existingOrder) {
              const productId = pd.productId ?? (rp.productId ? Number(rp.productId) : null);
              const total = Number(payment.amount ?? 0);
              const order = await prisma.order.create({
                data: {
                  userId: payment.userId,
                  totalPrice: total,
                  status: "COMPLETED",
                  billRefNumber: payment.providerRef || String(payment.id),
                  description: `Document purchase ${productDocumentId}`,
                  ProductOnOrder: productId ? {
                    create: [
                      {
                        productId,
                        quantity: 1,
                        unitPrice: total
                      }
                    ]
                  } : void 0
                }
              });
              try {
                await prisma.payment.update({ where: { id: payment.id }, data: { orderId: order.id } });
              } catch (updErr) {
                console.error("failed to link payment -> order (confirm):", updErr?.message || updErr);
              }
            }
          } catch (ordErr) {
            console.error("order create error (confirm):", ordErr?.message || ordErr);
          }
        }
      }
    } catch (err) {
      console.error("entitlement/create error (confirm):", err?.message || err);
    }
  }
  throw redirect(303, "/product?payment=success");
};
export {
  GET
};
